import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/fp/isEmpty';
import useClickOutside from '../../hooks/useClickOutside';
var ToggleButton = function ToggleButton(props) {
  var title = props.title,
    caret = props.caret;
  return /*#__PURE__*/React.createElement("a", {
    className: classNames('ModuleNavigation-dropdown dropdown-toggle justify-content-between', {
      inactive: !caret
    }),
    role: "button",
    id: "basic-nav-dropdown"
  }, /*#__PURE__*/React.createElement("span", null, title), caret && /*#__PURE__*/React.createElement("span", {
    className: "caret"
  }));
};
var DropdownMenu = function DropdownMenu(props) {
  var children = props.children;
  if (isEmpty(children)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    role: "menu",
    className: "dropdown-menu"
  }, children);
};
var AppMenuDropdownOpener = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var open = props.open,
    children = props.children,
    onDropdownClick = props.onDropdownClick;
  return /*#__PURE__*/React.createElement("li", {
    ref: ref,
    className: classNames('dropdown', {
      open: open
    }),
    onClick: onDropdownClick
  }, children);
});
export var AppMenuDropdown = function AppMenuDropdown(props) {
  var title = props.title,
    caret = props.caret,
    onToggleAppMenu = props.onToggleAppMenu,
    children = props.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var wrapperRef = useClickOutside(function () {
    return setIsOpen(false);
  });
  var handleDropdownClick = function handleDropdownClick() {
    var newState = !isOpen;
    setIsOpen(newState);
    onToggleAppMenu(newState);
  };
  var openWithChildren = !isEmpty(children) && isOpen;
  return /*#__PURE__*/React.createElement(AppMenuDropdownOpener, {
    open: openWithChildren,
    onDropdownClick: handleDropdownClick,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    title: title,
    caret: caret
  }), /*#__PURE__*/React.createElement(DropdownMenu, null, children));
};
export default AppMenuDropdown;
AppMenuDropdown.defaultProps = {
  caret: false
};
AppMenuDropdown.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  caret: PropTypes.bool,
  onToggleAppMenu: PropTypes.func
};